import { useEffect, useState } from "react";

const ShnoodlePawPrint = ({
  isVisible = true,
  rotationClass = "rotate-0",
  translationClass = "translate-y-0",
}) => {
  const opacity = isVisible ? "opacity-100" : "opacity-0";
  return (
    <div
      className={`flex flex-col items-center justify-center ${rotationClass} ${translationClass} ${opacity}`}
    >
      <i className="fas fa-paw text-color-background-tertiary dark:text-color-dark-background-tertiary text-2xl"></i>
    </div>
  );
};

const ShnoodleLoadingElement = () => {
  const [beat, setBeat] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setBeat((prevBeat) => prevBeat + 1);
    }, 300);

    return () => clearInterval(intervalId); // Cleanup the interval
  }, []); // Empty dependency array ensures the effect runs once when the component mounts

  const cycle = Math.floor(beat / 4);
  const beatInCycle = beat % 4;

  const rotationOptions = [
    "rotate-[80deg]",
    "rotate-[110deg]",
    "rotate-[60deg]",
    "rotate-[100deg]",
    "rotate-[90deg]",
  ];

  const translationOptions = [
    "-translate-y-1",
    "translate-y-0",
    "-translate-y-1",
    "translate-y-2",
  ];
  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <div className="flex flex-row items-center gap-4">
        <ShnoodlePawPrint
          isVisible={beatInCycle > 0}
          rotationClass={rotationOptions[cycle % rotationOptions.length]}
          translationClass={
            translationOptions[(cycle + 0) % translationOptions.length]
          }
        />
        <ShnoodlePawPrint
          isVisible={beatInCycle > 1}
          rotationClass={rotationOptions[(cycle + 1) % rotationOptions.length]}
          translationClass={
            translationOptions[(cycle + 1) % translationOptions.length]
          }
        />
        <ShnoodlePawPrint
          isVisible={beatInCycle > 2}
          rotationClass={rotationOptions[(cycle + 2) % rotationOptions.length]}
          translationClass={
            translationOptions[(cycle + 2) % translationOptions.length]
          }
        />
      </div>
    </div>
  );
};

const RaindropLoadingElement = ({ isShnoodle = true }) => {
  const [opacity, setOpacity] = useState("opacity-0");

  // Set opacity to 100% after 1 seconds.  This is to prevent a janky switch if an element loads quickly.
  setTimeout(() => {
    setOpacity("opacity-100");
  }, 1000);

  if (isShnoodle) {
    return <ShnoodleLoadingElement />;
  }

  return (
    <div
      className={`flex flex-row gap-2 w-full h-full items-center justify-center animate-pulse transition-all ${opacity}`}
    >
      <div className="bg-color-background-tertiary dark:bg-color-dark-background-tertiary rounded-full w-2 h-2" />
      <div className="bg-color-background-tertiary dark:bg-color-dark-background-tertiary rounded-full w-2 h-2" />
      <div className="bg-color-background-tertiary dark:bg-color-dark-background-tertiary rounded-full w-2 h-2" />
    </div>
  );
};

export default RaindropLoadingElement;
